import * as yup from 'yup'

export class VehicleCheckInFrontHeadOnPhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInFrontHeadOnPhotoFile?: File = undefined
}

export const vehicleCheckInFrontHeadOnPhotoValidationSchema = yup.object({
  vehicleCheckInFrontHeadOnPhotoFile: yup.mixed().notRequired()
})
